'use strict';

const COOKIE_NAME = 'sn';
const DEFAULT_SOCIAL_NETWORK = 'fb';
const SOCIAL_NETWORKS = ['fb', 'vk'];

const social = [
  '$q',
  'facebook',
  'vk',
  'userModel',
  'Storage',

  function ($q, facebook, vk, userModel, Storage) {
    var cookieStorage = new Storage('cookie');
    var socials = {
      fb: facebook,
      vk: vk
    };

    /**
     * Returns main social network option.
     * @returns {String}
     */
    function getMainSocialNetwork() {
      var mainSocialNetwork;

      // Get social network storred in user model or cookie storage
      if (userModel.item.id) {
        mainSocialNetwork = userModel.item.socialNetwork;
      } else {
        mainSocialNetwork = cookieStorage.get(COOKIE_NAME);
      }

      // Return default social network if value is invalid
      if (SOCIAL_NETWORKS.indexOf(mainSocialNetwork) === -1) {
        mainSocialNetwork = DEFAULT_SOCIAL_NETWORK;
      }

      return mainSocialNetwork;
    }

    return {
      login: function (networkName) {
        return socials[networkName].login();
      },

      getPhotoPermissions: function (networkName) {
        return socials[networkName].getPhotoPermissions();
      },

      getAlbums: function (networkName) {
        return socials[networkName].getAlbums();
      },

      getPhotosOfYou: function (networkName) {
        return socials[networkName].getPhotosOfYou();
      },

      getPhotos: function (networkName, albumId) {
        return socials[networkName].getPhotos(albumId);
      },

      getPhotoUrl: function (networkName, photoId) {
        return socials[networkName].getPhotoUrl(photoId);
      },

      fetchScripts: function (networkName) {
        return socials[networkName] && socials[networkName].fetchScript();
      },

      getSocialNetwork: function(networkName) {
        return socials[networkName];
      },

      getUserSocialNetwork: getMainSocialNetwork,
    };
  }
];

export default social;



// WEBPACK FOOTER //
// ./app/src/services/social.js